<template>
<basic-container v-loading="loading">
  <div class="title-warp">
    <h3 class="title">合同预览</h3>
    <el-button size="small" type="primary" style="margin-left: 30px" @click="$router.back()">返回</el-button>
  </div>
  <!-- <div class="pdf-wrap">
    <pdf v-for="i in numPages" :key="i" :src="src" :page="i" ref="myPdfComponent"></pdf>
  </div> -->
  <div class="embed-box">
    <embed height="1000px" width="100%" :src="base64" type="application/pdf" hidden=ture/>
  </div>
</basic-container>
</template>
<script>
// import pdf from 'vue-pdf'
// import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
export default {
  name: 'ContractDetail',
  data() {
    return {
      src: '',
      numPages: 0,
      loading: true,
      base64: ''
    }
  },
  activated() {
    this.loading = true
    this.src = ''
    this.numPages = 0
    this.getContractFile(this.$route.query.contractNo)
  },
  // components: {
  //   pdf
  // },
  methods: {
    async getContractFile(contractNo) {
      const res = await _api.contract.getContractFile({contractNo})
      if (!res || !res.ret || !res.data) {
        return
      }
      this.base64 = 'data:application/pdf;base64,' + res.data
      this.loading = false
      // this.showbase64Pdf(base64)
    },
    showbase64Pdf (base64) {
      this.src = pdf.createLoadingTask({ url: base64, CMapReaderFactory });
      this.src.promise.then(pdf => {
        this.loading = false
        this.numPages = pdf.numPages;
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.title-warp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.pdf-wrap {
  min-height: 600px;
}
.embed-box {
  width: 100%;
  height: 900px;
  overflow: hidden;
  embed {
    transform: translateY(-40px);
    height: 900px;
    width: 100%;
  }
}
</style>